// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.7.3_webpack@5.77.0/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.7.3_webpack@5.77.0/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".panelButton_mzp9r {\n  padding-bottom: 15px;\n}\n.panelButton_mzp9r::part(content) {\n  text-decoration: none;\n}", "",{"version":3,"sources":["webpack://./components/TopNavHeader/styles.module.scss"],"names":[],"mappings":"AAAA;EACI,oBAAA;AACJ;AAAI;EACI,qBAAA;AAER","sourcesContent":[".panelButton {\r\n    padding-bottom: 15px;\r\n    &::part(content) {\r\n        text-decoration: none;\r\n    }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"panelButton": "panelButton_mzp9r"
};
export default ___CSS_LOADER_EXPORT___;
